<template>
    <span class="tips" v-if="showTips">
        <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 icon-tips"
           style="height: 12px;"
           @mouseover="toggleExtraInfo(true)"
           @mouseout="toggleExtraInfo(false)"
        >
           <div  class="extra-info" v-if="visible">
               <div v-for="(v, k) in extra">
                 <div  class="extra-info-row" v-if="k !== 'max'">
                   <span class="extra-info-key">{{ k + 'F' }}</span>
                   <span class="extra-info-value">{{ Array.from(v).sort((x, y) => y - x).join(' | ') }}</span>
                 </div>
               </div>
           </div>
        </i>
    </span>
</template>

<script setup>
import {computed, ref} from "vue";

const props = defineProps(['extra'])
const visible = ref(false);
const showTips = computed(() => {
  return props.extra && Object.keys(props.extra).length > 2;
})

const toggleExtraInfo = v => {
  visible.value = v;
}
</script>

<style lang="less" scoped>
.tips{
  position: absolute;
  right: -16px;
  top: 0;
}

.iconfont.icon-tips{
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #1D83E6;
  top: -12px;
  left: 6px;
}

.extra-info{
  position: absolute;
  right: -160px;
  width: 140px;

  background-color: #fff;
  white-space: nowrap;

  border: 1px solid #edeef2;
  border-left-color: #3D7AD3;
  padding: 15px 8px;
  font-size: 14px;
  border-radius: 1px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.12);
  z-index: 100;

  &-row{
    display: table-row;
    margin-bottom: 6px;

    &:after{
      content: '';
      position: absolute;
      left: -15px;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 6px;
      display: block;
      border: 6px solid transparent;
      border-bottom: 6px solid #3D7AD3;
      transform: rotate(-90deg);
    }
  }

  &-key{
    display: table-cell;
    color: #9B9FA8;
  }

  &-value{
    width: 100px;
    display: table-cell;
    color: #5D6069;
    padding-left: 10px;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>